import React from 'react'
import MultiPlayView, { MultiPlayViewProps } from './MultiPlayView'

type HostPlayViewProps = MultiPlayViewProps

const HostPlayView: React.FC<HostPlayViewProps> = (props: HostPlayViewProps) => {
  return <MultiPlayView {...props} />
}

export default HostPlayView
